module.exports = __webpack_public_path__ + "static/media/22.b6ae2324.jpg";